import React, { useState, useEffect } from "react";
import { API_URL } from "../apiConfig.js";
import { Navigate, useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import spinner from "../image/spinner.svg";
import Navbar from "../Component/navbar";
// import Globe from "../Component/magicui/globe.tsx";
import CSRFToken from "../cookies.js";
import TYPE from "../reducer/Type.js";
import Footer from "../Component/footer.jsx";

const CreateResume = ({ isAuthenticated }) => {
  const [jobPosition, setJobPosition] = useState("");
  const [responseJson, setResponseJson] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchUserProfile = async () => {
    try {
      const authToken = localStorage.getItem("access");

      const response = await fetch(`${API_URL}/fetch-user-profile`, {
        method: "GET",
        headers: {
          "X-CSRFToken": CSRFToken(document.cookie),
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = await response.json();

      dispatch({
        type: TYPE.GET_USER_SUCCESS,
        payload: {
          user: data,
        },
      });
      return;
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  // Check authentication status on component mount
  useEffect(() => {
    const authToken = localStorage.getItem("access");
    if (!authToken) {
      // If authentication token not found, navigate to login page
      navigate("/login");
    }
  }, []);

  const handleButtonClick = async (e) => {
    e.preventDefault();
    if (!jobPosition.trim()) {
      setErrorMessage("Please provide input data."); // Set error message if input field is empty
      return;
    }
    setLoading(true);
    setButtonDisabled(true);

    try {
      const authToken = localStorage.getItem("access");
      const response = await fetch(`${API_URL}/resume_ai`, {
        method: "POST",
        headers: {
          "X-CSRFToken": CSRFToken(document.cookie),
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ job_position: jobPosition }),
      });
      const data = await response.json();
      setResponseJson(data.output);
      navigate("/template", { state: { outputData: data.output } });
      setErrorMessage("");
    } catch (error) {
      setResponseJson(null);
      setErrorMessage("Error occurred while fetching data");
      console.error("Error:", error);
    } finally {
      setLoading(false);
      setButtonDisabled(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />

      <div className="flex flex-col flex-grow mx-20 my-8 max-md:mx-2">
        <div className="my-5 font-bold text-8xl wi max-md:text-4xl max-md:my-2 max-md:text-center">
          Help Me Create A Resume For
        </div>
        <div className="flex gap-5 py-2 pr-3.5 pl-9 border-2 border-black border-solid max-w-[940px] rounded-[100px] max-md:flex-wrap max-md:pl-5 max-md:gap-0">
          <input
            className="self-end flex-auto block w-3/5 px-3 py-1 font-bold text-orange-500 text-7xl focus:outline-none max-md:w-36 max-md:text-3xl"
            placeholder="Software Developer with 5 years experience"
            name="resumefor"
            value={jobPosition}
            onChange={(e) => setJobPosition(e.target.value)}
            required
          />
          <div className="flex justify-end">
            <div
              onClick={handleButtonClick}
              disabled={buttonDisabled}
              className="flex justify-center items-center px-6 bg-white rounded-full border border-black border-solid h-[100px] stroke-[1px] w-[100px] max-md:px-2 max-md:w-[50px] max-md:h-[50px]"
            >
              {loading ? (
                <img
                  loading="lazy"
                  src={spinner}
                  alt="spinner"
                  className="w-12 h-12 animate-spin max-md:w-6 max-md:h-6"
                />
              ) : (
                <img
                  loading="lazy"
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/395eff768bf5008660a50c05ecbf846f9939e43ba67ae2e3117c057669e9f3dc?apiKey=e64c88474a2c4290b8b66f50b4a39c22&"
                  alt="Software Developer Badge Icon"
                  className="aspect-square w-[50px] max-md:w-[25px]"
                />
              )}
            </div>
          </div>
        </div>
        {errorMessage && (
          <div className="text-red-500 max-md:text-xs">{errorMessage}</div>
        )}
      </div>

      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.AuthReducer.isAuthenticated,
  };
};

export default connect(mapStateToProps)(CreateResume);
